import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import dayjs from 'dayjs';
import { ReactNode, Suspense } from 'react';

import { GrassColumnHeader, GrassRowHeader } from './GrassBody.parts';
import GrassCalendar from './GrassBody.parts/GrassCalendar';
import GrassCalendarSkeleton from './GrassBody.parts/GrassCalendarSkeleton';

import { GrassWidgetProps } from '@/shared/types';
import { ServerAuth } from '@/shared/auth';

interface GrassBodyProps extends GrassWidgetProps {
  todayGrassTileComponent: ReactNode;
}

const GrassBody = ({
  grassListPromise,
  todayGrassTileComponent,
}: GrassBodyProps) => {
  const isAuth = !!ServerAuth.getAccessToken();
  const startDate = dayjs().startOf('year');

  return (
    <Box
      className={twJoin(
        'flex h-full w-[706px] min-w-[706px] flex-col gap-2 px-4 pb-5 pt-4',
        'desktop:px-6 desktop:pb-0 desktop:pt-5'
      )}
    >
      <GrassRowHeader startDate={startDate} />
      <Box className="flex h-[82px] gap-2">
        <GrassColumnHeader />
        <Suspense fallback={<GrassCalendarSkeleton />}>
          <GrassCalendar
            isAuth={isAuth}
            grassListPromise={grassListPromise}
            todayGrassTileComponent={todayGrassTileComponent}
          />
        </Suspense>
      </Box>
    </Box>
  );
};

export default GrassBody;
